export const webview = {
    webviewContent: 'Это внешний URL-адрес, и он откроется в новом окне. Открыть?',
    webviewButtonOpenTitle: 'Открыть',
    webviewButtonCopyTitle: 'Скопировать URL',
    webviewButtonOpenAgainTitle: 'Открыть снова',
    notifications: {
      urlCopied: 'URL скопирован!'
    }
}
